import { resourceSliceFactory } from "infrastructure/store/state";
import { MenuItem } from "consts/openBanking";
import type { OpenBankingState } from "./types";

const state: OpenBankingState = {
    [MenuItem.BankingSDK]: resourceSliceFactory(),
    [MenuItem.IbanXS]: resourceSliceFactory(),
    [MenuItem.BankingSDKRecipients]: resourceSliceFactory(),
    [MenuItem.BankingSDKConnectorsRecipientsPivot]: resourceSliceFactory(),
    [MenuItem.IbanXSBanksRecipientsPivot]: resourceSliceFactory(),
    [MenuItem.IbanXSBanksCountriesPivot]: resourceSliceFactory(),
};

export const sliceToken = 'openBanking';

export default state;
